module.exports = __webpack_public_path__ + "img/qrcode.d2f2f4d1.jpg";